import script from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=57fb4c90&lang=css"

const __exports__ = script;

export default __exports__